const statusStyles: Record<string, string> = {
  pending: "bg-yellow-100 text-yellow-800",
  approved: "bg-green-100 text-green-800",
  published: "bg-green-100 text-green-800",
  rejected: "bg-red-100 text-red-800",
  draft: "bg-gray-100 text-gray-800",
  sending: "bg-yellow-100 text-yellow-800",
  dead: "bg-red-100 text-red-800",
  sent: "bg-blue-100 text-blue-800",
  delivered: "bg-green-100 text-green-800",
  bounced: "bg-red-100 text-red-800",
  failed: "bg-red-100 text-red-800",
  active: "bg-green-100 text-green-800",
  suspended: "bg-red-100 text-red-800",
};

const statusLabels: Record<string, string> = {
  pending: "Na čekanju",
  approved: "Odobreno",
  published: "Objavljeno",
  rejected: "Odbijeno",
  draft: "Nacrt",
  sending: "Šalje se",
  dead: "Nije poslano",
  sent: "Poslano",
  delivered: "Dostavljeno",
  bounced: "Odbijeno",
  failed: "Neuspjelo",
  active: "Aktivno",
  suspended: "Suspendirano",
};

interface StatusBadgeProps {
  status: string;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${statusStyles[status] || "bg-gray-100 text-gray-800"} ${className || ""}`}>
      {statusLabels[status] || status}
    </span>
  );
}
